import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BadgeAssignLayer from "../components/BadgeAssignLayer";

const BadgeAssignFormPage = () => {
    return (
        <MasterLayout>
            <BadgeAssignLayer />
        </MasterLayout>
    );
};

export default BadgeAssignFormPage;
